function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// ------------------ INIT LIGHTBOX ZOOM ------------------

let lightboxEl = document.querySelector('#custom-lightbox');
if (lightboxEl) {
(() => {
  // ======= CONFIG & GLOBALS =======
  const SWIPER_HOST = ".main-carosel, .main-swiper, .swiper";
  const IMG_SEL     = ".main-swiper img, .swiper .swiper-slide img";

  // Autoplay config
  const AUTOPLAY_MS     = 24000;
  const RESUME_DELAY_MS = 23000;
  let __autoplayTimer   = null;
  let __autoplayResumeTO= null;

  window.__zoomAbort               = window.__zoomAbort || null;
  window.__variantListenerBound    = window.__variantListenerBound || false;
  window.__genderListenerBound     = window.__genderListenerBound  || false;
  window.__lastGender              = window.__lastGender || null;

  let __currentScopeEl = null;

  // CSS helpers (once)
  (function injectCSS(){
    if (document.getElementById("zoom-overlay-unblock")) return;
    const style = document.createElement("style");
    style.id = "zoom-overlay-unblock";
    style.textContent = `
      #custom-lightbox .disabled{opacity:.35;pointer-events:none;}
      #custom-lightbox .lightbox-content{ position:relative; padding-bottom:28px; }
      #custom-lightbox .lightbox-dots{ position:absolute; left:50%; transform:translateX(-50%); bottom:max(10px, env(safe-area-inset-bottom)); display:flex; gap:8px; z-index:10000; }
      #custom-lightbox .lightbox-dot{ width:8px; height:8px; border-radius:50%; background:rgba(0,0,0,.25); transition:background .25s; }
      #custom-lightbox .lightbox-dot.active{ background:#111; }
    `;
    document.head.appendChild(style);
  })();

  // ======= HELPERS =======
  function waitForMainImages(selector = IMG_SEL, maxTries = 40, intervalMs = 200) {
    return new Promise((resolve, reject) => {
      let tries = 0;
      const timer = setInterval(() => {
        const imgs = Array.from(document.querySelectorAll(selector));
        const anyLoaded = imgs.some(img => img.complete && img.naturalWidth > 0);
        if (imgs.length && anyLoaded) { clearInterval(timer); resolve(imgs); }
        if (++tries > maxTries) { clearInterval(timer); reject(new Error("Images not ready")); }
      }, intervalMs);
    });
  }

  async function waitForSwiperStable({
    hostSelector = SWIPER_HOST,
    imgSelector  = IMG_SEL,
    quietMs      = 300,
    maxWaitMs    = 8000
  } = {}) {
    const host = document.querySelector(hostSelector);
    if (!host) return waitForMainImages(imgSelector);

    let lastChange = performance.now();
    const started  = performance.now();
    const mo = new MutationObserver(() => { lastChange = performance.now(); });
    mo.observe(host, { childList:true, subtree:true, attributes:true, attributeFilter:["src","srcset","class"] });

    return new Promise((resolve) => {
      (function tick(){
        const now = performance.now();
        const quiet = (now - lastChange) >= quietMs;

        const imgs = Array.from(document.querySelectorAll(imgSelector));
        const anyLoaded = imgs.some(i => i.complete && i.naturalWidth > 0);

        const el = document.querySelector(hostSelector);
        const initialized = !!(el && (el.classList.contains("swiper-initialized") || el.querySelector(".swiper-initialized")));

        const loaderActive = !!document.querySelector(".loader.active, body.loader-active, .size-secection[style*='display: block']");

        if (quiet && anyLoaded && initialized && !loaderActive) {
          mo.disconnect(); return resolve(imgs);
        }
        if ((now - started) > maxWaitMs) {
          mo.disconnect(); return resolve(imgs);
        }
        requestAnimationFrame(tick);
      })();
    });
  }

  function resolveSlideImage(target) {
    if (!target || !(target instanceof Element)) return null;
    if (target.matches("img")) return target;
    const pict = target.closest("picture"); if (pict) { const i = pict.querySelector("img"); if (i) return i; }
    const fig  = target.closest("figure");  if (fig)  { const i = fig.querySelector("img");  if (i) return i; }
    const slide = target.closest(".swiper-slide"); if (slide) { const i = slide.querySelector("img"); if (i) return i; }
    const gallery = target.closest(".main-carosel, .main-swiper, .swiper");
    if (gallery) { const i = gallery.querySelector(".swiper-slide img, .main-swiper img"); if (i) return i; }
    return null;
  }

  function getScopedImages() {
    if (__currentScopeEl && document.body.contains(__currentScopeEl)) {
      const inScope = Array.from(__currentScopeEl.querySelectorAll(".main-swiper img"));
      if (inScope.length) return inScope;
    }
    const fallbackScope = document.querySelector(".main-carosel") || document.querySelector(".main-swiper") || document.querySelector(".swiper");
    if (fallbackScope) {
      const imgs = Array.from(fallbackScope.querySelectorAll(".main-swiper img"));
      if (imgs.length) return imgs;
    }
    return Array.from(document.querySelectorAll(IMG_SEL));
  }

  function setScopeFromTarget(targetEl) {
    __currentScopeEl =
      targetEl.closest(".main-carosel") ||
      targetEl.closest(".main-swiper") ||
      targetEl.closest(".swiper") ||
      __currentScopeEl || document.querySelector(".main-carosel") || document.querySelector(".main-swiper");
  }

  // ======= SWIPE (mobile) =======
  function bindSwipeNav(lightboxEl, getZoomed, onPrev, onNext, onInteract) {
    if (lightboxEl.__swipeBound) return;
    lightboxEl.__swipeBound = true;

    let startX = 0, startY = 0, lastX = 0, lastY = 0, startT = 0;
    let moved = false, multiTouch = false, tracking = false;

    const X_TOL = 18, SWIPE_MIN = 50, VEL_MIN = 0.35;

    const onStart = (x, y, touchesCount) => {
      multiTouch = touchesCount > 1;
      tracking = true; moved = false;
      startX = lastX = x; startY = lastY = y; startT = performance.now();
      onInteract && onInteract("touchstart");
    };
    const onMove = (x, y) => {
      if (!tracking || multiTouch) return;
      lastX = x; lastY = y;
      if (!moved) {
        const dx = Math.abs(lastX - startX);
        const dy = Math.abs(lastY - startY);
        if (!getZoomed() && dx > X_TOL && dx > dy) moved = true;
      }
    };
    const onEnd = () => {
      if (!tracking) return; tracking = false;
      if (multiTouch) { multiTouch = false; return; }
      if (getZoomed && getZoomed()) return;

      const dt = Math.max(1, performance.now() - startT);
      const dx = lastX - startX;
      const vx = dx / dt;

      if (Math.abs(dx) >= SWIPE_MIN || Math.abs(vx) >= VEL_MIN) {
        if (dx < 0) onNext(); else onPrev();
      }
      onInteract && onInteract("touchend");
    };

    if (window.PointerEvent) {
      lightboxEl.addEventListener("pointerdown", (e) => {
        if (e.pointerType !== "touch") return;
        onStart(e.clientX, e.clientY, 1);
      }, { passive:true });
      lightboxEl.addEventListener("pointermove", (e) => {
        if (e.pointerType !== "touch") return;
        onMove(e.clientX, e.clientY);
      }, { passive:true });
      lightboxEl.addEventListener("pointerup", (e) => {
        if (e.pointerType !== "touch") return;
        onEnd();
      }, { passive:true });
      lightboxEl.addEventListener("pointercancel", () => { tracking = false; }, { passive:true });
    } else {
      lightboxEl.addEventListener("touchstart", (e) => {
        const t = e.touches && e.touches[0]; if (!t) return;
        onStart(t.clientX, t.clientY, e.touches.length);
      }, { passive:true });
      lightboxEl.addEventListener("touchmove", (e) => {
        const t = e.touches && e.touches[0]; if (!t) return;
        onMove(t.clientX, t.clientY);
      }, { passive:true });
      lightboxEl.addEventListener("touchend", () => { onEnd(); }, { passive:true });
      lightboxEl.addEventListener("touchcancel", () => { tracking = false; }, { passive:true });
    }
  }

  // ======= DOTS =======
  function ensureDotsContainer(lightboxEl){
    const content = lightboxEl.querySelector(".lightbox-content") || lightboxEl;
    let dots = content.querySelector(".lightbox-dots");
    if (!dots) {
      dots = document.createElement("div");
      dots.className = "lightbox-dots";
      content.appendChild(dots);
    }
    return dots;
  }
  function renderDots(lightboxEl, count){
    const dots = ensureDotsContainer(lightboxEl);
    dots.innerHTML = "";
    for (let i=0; i<count; i++){
      const d = document.createElement("span");
      d.className = "lightbox-dot";
      dots.appendChild(d);
    }
  }
  function setActiveDot(lightboxEl, index){
    const dots = lightboxEl.querySelectorAll(".lightbox-dot");
    dots.forEach((d,i)=>d.classList.toggle("active", i===index));
  }

  // ======= AUTOPLAY STATE =======
  let isOpen = false;
 
  let zoomed = false; // shared with zoom handlers

  function stopAutoplay() {
    if (__autoplayTimer) { clearInterval(__autoplayTimer); __autoplayTimer = null; }
    if (__autoplayResumeTO) { clearTimeout(__autoplayResumeTO); __autoplayResumeTO = null; }
  }
  function startAutoplay(nextFn) {
    // run only when open + not zoomed + not hovered
    if (!isOpen || zoomed) return;
    stopAutoplay();
    __autoplayTimer = setInterval(() => nextFn && nextFn(), AUTOPLAY_MS);
  }
  function pauseThenResume(nextFn) {
    // pause now, resume later only if allowed state
    if (__autoplayTimer) { clearInterval(__autoplayTimer); __autoplayTimer = null; }
    if (__autoplayResumeTO) clearTimeout(__autoplayResumeTO);
    __autoplayResumeTO = setTimeout(() => {
      if (!zoomed && isOpen) startAutoplay(nextFn);
    }, RESUME_DELAY_MS);
  }

  // ======= LIGHTBOX / ZOOM =======
  window.initLightboxZoom = async function initLightboxZoom(tag = "init") {
    if (window.__zoomAbort) { window.__zoomAbort.abort(); }
    stopAutoplay();

    const ac = new AbortController();
    const signal = ac.signal;
    window.__zoomAbort = ac;

    try { await waitForSwiperStable(); } catch(e) {}
    try { await waitForMainImages(IMG_SEL); } catch(e) { return; }

    const lightbox    = document.getElementById("custom-lightbox");
    const lightboxImg = document.getElementById("lightbox-image");
    const closeBtn    = document.querySelector(".lightbox-close");
    const prevBtn     = document.querySelector(".lightbox-prev");
    const nextBtn     = document.querySelector(".lightbox-next");
    const isMobile    = window.matchMedia("(max-width: 768px)").matches;

    let dragging = false, startX = 0, startY = 0, tx = 0, ty = 0;
    let currentIndex = 0;

    function resetZoom() {
      zoomed = false;
      tx = 0; ty = 0; dragging = false;
      if (!lightboxImg) return;
      lightboxImg.style.transform = "translate(0px,0px) scale(1)";
      lightboxImg.classList.remove("zoom-out");
      lightboxImg.classList.add("zoom-in");
      lightboxImg.style.cursor = isMobile ? "auto" : "zoom-in";
      // zoom reset ke baad autoplay allowed
      startAutoplay(next);
    }

    function setImage(i) {
      const imgs = getScopedImages();
      const el = imgs[i];
      if (!el || !lightboxImg) return;
      lightboxImg.src = el.currentSrc || el.src;
      lightboxImg.alt = el.alt || "";
      resetZoom();
      setActiveDot(lightbox, i);
    }

    function open(i) {
      const imgs = getScopedImages();
      if (!imgs.length || !lightbox) return;

      renderDots(lightbox, imgs.length);

      currentIndex = Math.max(0, Math.min(i, imgs.length - 1));
      lightbox.style.display = "block";
      document.documentElement.style.overflow = "hidden";
      isOpen = true;
      setImage(currentIndex);
      startAutoplay(next);
    }

    function close() {
      if (!lightbox) return;
      lightbox.style.display = "none";
      document.documentElement.style.overflow = "";
      isOpen = false;
      stopAutoplay();
      resetZoom();
    }

    function prev() {
      const n = getScopedImages().length; if (n <= 1) return;
      currentIndex = (currentIndex - 1 + n) % n; setImage(currentIndex);
    }
    function next() {
      const n = getScopedImages().length; if (n <= 1) return;
      currentIndex = (currentIndex + 1) % n; setImage(currentIndex);
    }

    // Open from gallery click
    // document.addEventListener("click", (e) => {
    //   const t = e.target;
    //   if (!(t instanceof Element)) return;
    //   if (!t.closest(".main-carosel") && !t.closest(".main-swiper") && !t.closest(".swiper")) return;
    //   const imgEl = resolveSlideImage(t);
    //   if (!imgEl) return;
    //   setScopeFromTarget(imgEl);
    //   const imgs = getScopedImages();
    //   const i = imgs.indexOf(imgEl);
    //   if (i < 0) return;
    //   open(i);
    // }, { signal, capture: true });
document.addEventListener("click", (e) => {
  const t = e.target;
  if (!(t instanceof Element)) return;

  // --- FIX: ignore next/prev button clicks ---
  if (
    t.closest(".swiper-button-next") ||
    t.closest(".swiper-button-prev") ||
    t.classList.contains("swiper-button-next") ||
    t.classList.contains("swiper-button-prev")
  ) {
    return; // allow default swiper button click
  }
  // ------------------------------------------

  // Only trigger zoom from images inside gallery
  if (!t.closest(".main-carosel") &&
      !t.closest(".main-swiper") &&
      !t.closest(".swiper")) return;

  const imgEl = resolveSlideImage(t);
  if (!imgEl) return;

  setScopeFromTarget(imgEl);
  const imgs = getScopedImages();
  const i = imgs.indexOf(imgEl);
  if (i < 0) return;

  open(i);
}, { signal, capture: true });


    // Controls
    if (closeBtn) closeBtn.addEventListener("click", () => { close(); }, { signal });
    if (prevBtn)  prevBtn.addEventListener("click", () => { prev();  pauseThenResume(next); }, { signal });
    if (nextBtn)  nextBtn.addEventListener("click", () => { next();  pauseThenResume(next); }, { signal });

    // Dots click
    ensureDotsContainer(lightbox);
    lightbox.addEventListener("click", (e) => {
      const dot = e.target.closest(".lightbox-dot");
      if (!dot) return;
      const dots = Array.from(lightbox.querySelectorAll(".lightbox-dot"));
      const idx = dots.indexOf(dot);
      if (idx >= 0) {
        currentIndex = idx;
        setImage(currentIndex);
        pauseThenResume(next);
      }
    }, { signal });

    // Backdrop close
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) close();
    }, { signal });

    // Hover handling (desktop): hover => stop; leave => resume (if not zoomed)
    // lightbox.addEventListener("mouseenter", () => {
    //   isHovered = true;
    //   stopAutoplay();
    // }, { signal });
    // lightbox.addEventListener("mouseleave", () => {
    //   isHovered = false;
    //   startAutoplay(next);
    // }, { signal });

    // Keyboard
    document.addEventListener("keydown", (e) => {
      if (!isOpen || !lightbox || lightbox.style.display !== "block") return;
      if (e.key === "ArrowLeft")  { prev(); pauseThenResume(next); }
      if (e.key === "ArrowRight") { next(); pauseThenResume(next); }
      if (e.key === "Escape")     close();
    }, { signal });

    // Zoom toggle (click)
    lightboxImg.addEventListener("click", () => {
      if (!zoomed) {
        zoomed = true;
        lightboxImg.style.transform = `translate(0px,0px) scale(2)`;
        lightboxImg.classList.add("zoom-out");
        lightboxImg.classList.remove("zoom-in");
        lightboxImg.style.cursor = "grab";
        stopAutoplay(); // zoom IN -> stop autoplay
      } else {
        resetZoom();    // zoom OUT -> may resume (if not hovered)
      }
    }, { signal });

    // Wheel zoom (desktop)
    lightboxImg.addEventListener("wheel", (e) => {
      e.preventDefault();
      // Simple thresholded zoom behaviour
      const step = e.deltaY < 0 ? 0.2 : -0.2;
      const current = lightboxImg.style.transform.match(/scale\(([^)]+)\)/);
      let s = current ? parseFloat(current[1]) : 1;
      s = Math.max(1, Math.min(5, s + step));
      zoomed = s > 1.01;
      if (zoomed) stopAutoplay(); else startAutoplay(next);
      const translate = lightboxImg.style.transform.match(/translate\([^)]+\)/) || ["translate(0px,0px)"];
      lightboxImg.style.transform = `${translate[0]} scale(${s})`;
      lightboxImg.classList.toggle("zoom-out", zoomed);
      lightboxImg.classList.toggle("zoom-in", !zoomed);
      lightboxImg.style.cursor = zoomed ? "grab" : (window.matchMedia("(max-width: 768px)").matches ? "auto" : "zoom-in");
    }, { passive: false, signal });

    // Pan (desktop)
    lightboxImg.addEventListener("mousedown", (e) => {
      if (!zoomed) return;
      stopAutoplay();
      const m = lightboxImg.style.transform.match(/translate\(([^,]+)px,\s*([^)]+)px\)/);
      const curX = m ? parseFloat(m[1]) : 0;
      const curY = m ? parseFloat(m[2]) : 0;
      dragging = true;
      startX = e.clientX - curX;
      startY = e.clientY - curY;
      lightboxImg.style.cursor = "grabbing";
    }, { signal });

    document.addEventListener("mousemove", (e) => {
      if (!dragging || !zoomed) return;
      tx = e.clientX - startX;
      ty = e.clientY - startY;
      const scaleMatch = lightboxImg.style.transform.match(/scale\(([^)]+)\)/);
      const s = scaleMatch ? parseFloat(scaleMatch[1]) : 2;
      lightboxImg.style.transform = `translate(${tx}px, ${ty}px) scale(${s})`;
    }, { signal });

    document.addEventListener("mouseup", () => {
      if (!zoomed) return;
      dragging = false;
      lightboxImg.style.cursor = "grab";
    }, { signal });

    // Swipe nav + autoplay coordination on mobile
    bindSwipeNav(
      lightbox,
      () => zoomed,
      () => { prev(); pauseThenResume(next); },
      () => { next(); pauseThenResume(next); },
      ()  => { pauseThenResume(next); }
    );
  };

  // ======= VARIANT LISTENER =======
  function initVariantListener() {
    if (window.__variantListenerBound) return;
    const tryBind = () => {
      if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
        window.__variantListenerBound = true;
        subscribe(PUB_SUB_EVENTS.variantChange, async ({ data }) => {
          await waitForSwiperStable();
          window.initLightboxZoom("variantChange");
          if (typeof window.addPopup === "function") window.addPopup(data.variant);
        });
      } else {
        setTimeout(tryBind, 300);
      }
    };
    tryBind();
  }

  // ======= GENDER LISTENER =======
  function initGenderListener() {
    if (window.__genderListenerBound) return;
    window.__genderListenerBound = true;

    const bindWithPubSub = () => {
      if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, async ({ data }) => {
          const g = data?.selectedOptions?.Gender || null;
          if (!g || g === window.__lastGender) return;
          window.__lastGender = g;
          await waitForSwiperStable();
          window.initLightboxZoom("genderChange");
          if (typeof window.addPopup === "function") window.addPopup({ title: `Gender → ${g}` });
        });
        return true;
      }
      return false;
    };

    if (!bindWithPubSub()) {
      const retry = setInterval(() => { if (bindWithPubSub()) clearInterval(retry); }, 300);
    }

    // Fallback: DOM radios
    document.addEventListener("change", async (e) => {
      const t = e.target;
      if (!t || t.tagName !== "INPUT" || t.type !== "radio") return;
      const fs = t.closest('fieldset[data-name="Gender"]');
      if (!fs) return;

      const g = t.value || t.getAttribute("data-value");
      if (!g || g === window.__lastGender) return;
      window.__lastGender = g;

      await waitForSwiperStable();
      window.initLightboxZoom("genderChange(dom)");
      if (typeof window.addPopup === "function") window.addPopup({ title: `Gender → ${g}` });
    }, { once: false });
  }

  // ======= BOOT =======
  document.addEventListener("DOMContentLoaded", () => {
    window.initLightboxZoom("DOMContentLoaded");
    initVariantListener();
    initGenderListener();
  });
})();
}
// ==== Lightbox end === //

function extractSectionId(element) {
  element = element.classList.contains("shopify-section")
    ? element
    : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );
  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });
  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            window.ultimateDataLayer.recommendationsDataPdp(this);
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class Carosel extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector(".carosel.main-carosel"); // DOM element

    // Desktop Settings
    this.spaceBetweenDesktop = this.getAttribute("data-space-between-desktop");
    this.slidesPerViewDesktop = this.getAttribute("data-slides-per-view-desktop");
    this.showScrollbarDesktop = this.getAttribute("data-show-scrollbar-desktop");
    this.showNavigationDesktop = this.getAttribute("data-show-navigation-desktop");

    // Mobile Settings
    this.spaceBetweenMobile = this.getAttribute("data-space-between-mobile");
    this.slidesPerViewMobile = this.getAttribute("data-slides-per-view-mobile");
    this.showScrollbarMobile = this.getAttribute("data-show-scrollbar-mobile");
    this.showNavigationMobile = this.getAttribute("data-show-navigation-mobile");

    this.paginationEnabled = this.getAttribute("data-pagination");
    this.loop = this.getAttribute("data-loop");

    this.fraction = this.querySelector('.custom-fraction');
  }

  connectedCallback() {
    // Delay initialization to ensure DOM is ready (important for dynamically fetched HTML)
    requestAnimationFrame(() => {
      this.initSwiper();
    });
  }

  disconnectedCallback() {}

  updateFraction(swiper) {
    if (!this.fraction) return;

    const activeSlide = swiper.slides[swiper.activeIndex];
    const current = activeSlide.getAttribute('data-custom-index');

    if (!current) return;

    this.fraction.textContent = `${current}`;
  }

  initSwiper() {
    // Initialize Swiper first
    this.swiper = new Swiper(this.swiperEl, {
      initialSlide: 0,
      loop: this.loop ? JSON.parse(this.loop) : false,
      navigation: {
        nextEl: ".swiper-button-next.main-buttons",
        prevEl: ".swiper-button-prev.main-buttons",
      },
      pagination: this.paginationEnabled ? {
        el: ".swiper-pagination-wrapper",
        type: "fraction",
        enabled: false,
        clickable: true,
      } : false,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: +this.slidesPerViewDesktop || "auto",
          spaceBetween: +this.spaceBetweenDesktop || 16,
          navigation: {
            enabled: this.showNavigationDesktop
              ? JSON.parse(this.showNavigationDesktop)
              : false,
          },
          scrollbar: {
            enabled: this.showScrollbarDesktop
              ? JSON.parse(this.showScrollbarDesktop)
              : false,
          },
        },
        0: {
          slidesPerView: +this.slidesPerViewMobile || "auto",
          spaceBetween: +this.spaceBetweenMobile || 16,
          navigation: {
            enabled: this.showNavigationMobile
              ? JSON.parse(this.showNavigationMobile)
              : false,
          },
          scrollbar: {
            enabled: this.showScrollbarMobile
              ? JSON.parse(this.showScrollbarMobile)
              : false,
          },
        },
      },
      on: {
        init: (swiper) => {
          this.updateFraction(swiper); // Show initial fraction
        },
        slideChange: (swiper) => {
          this.updateFraction(swiper); // Update fraction on slide change
        }
      },
    });
  }
}

if (!customElements.get("carosel-component")) {
  customElements.define("carosel-component", Carosel);
}

class EditorialCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.classList.contains("has-two-buttons")) {
      this.addEventListener("click", this.handleImageClick);
    }
  }

  disconnectedCallback() {}

  clickHandler(event) {
    const ctaUrl = event.target.getAttribute("data-cta-url");
    window.location.href = ctaUrl;
  }
}

class CustomerEntryTabs extends HTMLElement {
  constructor() {
    super();
    this.tabBtns = this.querySelectorAll(".customer-entry-btn");
    this.recoverPassBtns = this.querySelectorAll(".recover-btn");
    this.recoveryTab = this.querySelector(".recover-password-tab");
    this.loginTab = this.querySelector(".login-tab");
    this.submitBtns = this.querySelectorAll("form button.submit-btn");
  }

  connectedCallback() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener("click", this.openTab.bind(this));
    });
    this.recoverPassBtns.forEach((btn) => {
      btn.addEventListener("click", this.openClosePasswordRecovery.bind(this));
    });
    this.submitBtns.forEach((btn) => {
      btn.addEventListener("click", this.validateForm.bind(this));
    });

    if(window.location.href.indexOf('#email-taken') > -1){
      this.querySelector('.error-mail-taken').classList.remove('hidden');
      setTimeout(function() {
        const cartBtn = document.querySelector('.nav-icons > a[data-id="account"]');
        if(window.innerWidth < 1024) {
          cartBtn.click();
        }
        else {
          cartBtn.dispatchEvent(new Event('mouseenter'));
        }
      },100);
    }

    if (window.location.href.indexOf("#recovery_successful") > -1) {
      this.querySelector(".error-mail-taken").classList.remove("hidden");
      setTimeout(function () {
        const cartBtn = document.querySelector(
          '.nav-icons > a[data-id="account"]'
        );
        const loginTabBtn = document.querySelector(
          '.customer-entry-btn[data-tab="header-account-login"]'
        );
        document
          .querySelector(".recover-password-msg")
          .classList.remove("hidden");
        document.dispatchEvent(new Event("showheader"));
        loginTabBtn.click();
        if(window.innerWidth < 1024) {
          cartBtn.click();
        }
        else {
          cartBtn.dispatchEvent(new Event('mouseenter'));
        }
      },100);
    }

    if(window.location.href.indexOf('#create-account') > -1){
      setTimeout(function() {
        const cartBtn = document.querySelector('.nav-icons > a[data-id="account"]');
        document.dispatchEvent(new Event("showheader"));
        if(window.innerWidth < 1024) {
          cartBtn.click();
        }
        else {
          cartBtn.dispatchEvent(new Event('mouseenter'));
        }
      },100);
    }

    if (window.location.href.indexOf("#incorrect_credentials") > -1) {
      this.querySelector(".incorrect-credentials-error").classList.remove(
        "hidden"
      );
      setTimeout(function () {
        const cartBtn = document.querySelector(
          '.nav-icons > a[data-id="account"]'
        );
        const loginTabBtn = document.querySelector(
          '.customer-entry-btn[data-tab="header-account-login"]'
        );
        document.dispatchEvent(new Event("showheader"));
        loginTabBtn.click();
        cartBtn.dispatchEvent(new Event("mouseenter"));
      }, 100);
    }
  }

  disconnectedCallback() {
    this.tabBtns.forEach((btn) => {
      btn.removeEventListener("click", this.openTab);
    });
    this.recoverPassBtns.forEach((btn) => {
      btn.removeEventListener("click", this.openClosePasswordRecovery);
    });
    this.submitBtns.forEach((btn) => {
      btn.removeEventListener("click", this.validateForm);
    });
  }
// validateForm(e) {
//   e.preventDefault();
//   let form = e.currentTarget.closest("form");
//   let selector = e.currentTarget.dataset.selector;
//   let form_errors = false;
//   let fields = form.querySelectorAll(".field");

//   fields.forEach((field) => {
//     let input = field.querySelector("input");
//     let value = input.value;
//     if (value == "") {
//       field.querySelector(".empty-field-error").classList.remove("hidden");
//       form_errors = true;
//     } else {
//       if (input.type == "email") {
//         let result = this.validateEmail(value);
//         if (!result) {
//           field.querySelector(".invalid-email-error").classList.remove("hidden");
//           form_errors = true;
//         }
//       }
//     }
//   });


//   // ✅ Custom phone validation block
// const phoneField = form.querySelector("#RegisterForm-phone");
// if (phoneField) {
//   const phoneValue = phoneField.value.trim();
//   const phoneErrorEmpty = phoneField.parentElement.querySelector(".empty-field-error");
//   const phoneErrorInvalid = phoneField.parentElement.querySelector(".invalid-phone-error");

//   // Always hide both errors initially
//   phoneErrorEmpty.classList.add("hidden");
//   phoneErrorInvalid.classList.add("hidden");

//   if (phoneValue === "") {
//     phoneErrorEmpty.classList.remove("hidden");
//     form_errors = true;
//   } else {
//     const phoneRegex = /^[0-9]{6,15}$/;
//     if (!phoneRegex.test(phoneValue)) {
//       phoneErrorInvalid.classList.remove("hidden");
//       form_errors = true;
//     }
//   }
// }

//   // ✅ Only submit if everything is valid
//   if (!form_errors) {
//     document.querySelector(`${selector}`).click();
//   }
// }

validateForm(e) {
  e.preventDefault();
  let form = e.currentTarget.closest("form");
  let selector = e.currentTarget.dataset.selector;
  let form_errors = false;
  let fields = form.querySelectorAll(".field");

  fields.forEach((field) => {
    let input = field.querySelector("input");
    let value = input.value;
    if (value == "") {
      field.querySelector(".empty-field-error").classList.remove("hidden");
      form_errors = true;
    } else {
      if (input.type == "email") {
        let result = this.validateEmail(value);
        if (!result) {
          field.querySelector(".invalid-email-error").classList.remove("hidden");
          form_errors = true;
        }
      }
    }
  });

  // ✅ Custom phone validation block
  // const phoneField = form.querySelector("#RegisterForm-phone");
  // if (phoneField) {
  //   const phoneValue = phoneField.value.trim();
  //   const uaeValidPhoneRegex = /^[2-79]\d{8}$/;
  //   if (!uaeValidPhoneRegex.test(phoneValue)) {
  //     alert("Please enter a valid UAE phone number (e.g. 501234567)");
  //     form_errors = true;
  //   } else {
  //     phoneField.value = "+971" + phoneValue;
  //   }
  // }

  // // ✅ Only submit if everything is valid
  // if (!form_errors) {
  //   document.querySelector(`${selector}`).click();
  // }

//const phoneField = form.querySelector("#RegisterForm-phone");
const phoneField = form.querySelector("#RegisterForm-phone, #AddressPhoneNew");
// if (phoneField) {
//   let phoneValue = phoneField.value.trim();

//   // Strip +971 if present
//   if (phoneValue.startsWith("+971")) {
//     phoneValue = phoneValue.replace("+971", "");
//   }

//   phoneValue = phoneValue.replace(/[^0-9]/g, "");

//   const uaeValidPhoneRegex = /^[2-79]\d{8}$/;

//   // Select message based on locale
//   const isArabic = document.documentElement.lang === "ar";

//   const alertMessage = isArabic
//     ? "يرجى إدخال رقم هاتف إماراتي صحيح (مثال: 501234567)"
//     : "Please enter a valid UAE phone number (e.g. 501234567)";

//   if (!uaeValidPhoneRegex.test(phoneValue)) {
//     alert(alertMessage);
//     form_errors = true;
//   } else {
//     phoneField.value = "+971" + phoneValue;
//   }
// }
if (phoneField) {
  let phoneValue = phoneField.value.trim();

  // 1. Clean the number first: remove any non-digit characters (+, spaces, etc.)
  phoneValue = phoneValue.replace(/[^0-9]/g, "");

  // 2. Strip UAE country code prefixes (971, 00971) if present
  if (phoneValue.startsWith("971")) {
    phoneValue = phoneValue.substring(3);
  } 
  else if (phoneValue.startsWith("00971")) {
    phoneValue = phoneValue.substring(5);
  }
  else if (phoneValue.startsWith("0")) {
    phoneValue = phoneValue.substring(1);
  }

  // 3. Validation Regex
  const uaeValidPhoneRegex = /^[2-79]\d{8}$/; 

  // 4. Select message based on locale
  const isArabic = document.documentElement.lang === "ar";
  const errorMessage = isArabic
    ? "يرجى إدخال رقم هاتف إماراتي صحيح (مثال: 501234567)"
    : "Please enter a valid UAE phone number (e.g. 501234567)";

  const phoneErrorInvalid = phoneField.parentElement.querySelector(".invalid-phone-error");

  if (!uaeValidPhoneRegex.test(phoneValue)) {
    if (phoneErrorInvalid) {
      phoneErrorInvalid.textContent = errorMessage;
      phoneErrorInvalid.classList.remove("hidden");
    }
    form_errors = true;
  } else {
    if (phoneErrorInvalid) phoneErrorInvalid.classList.add("hidden");
    // 5. If valid, format it back to international standard
    phoneField.value = "+971" + phoneValue;
  }
}
if (!form_errors) {
  document.querySelector(`${selector}`).click();
}



}

  // validateForm(e) {
  //   e.preventDefault();
  //   let form = e.currentTarget.closest("form");
  //   let selector = e.currentTarget.dataset.selector;
  //   let form_errors = false;
  //   let fields = form.querySelectorAll(".field");
  //   fields.forEach((field) => {
  //     let input = field.querySelector("input");
  //     let value = input.value;
  //     if (value == "") {
  //       field.querySelector(".empty-field-error").classList.remove("hidden");
  //       field.querySelector(".error-mail-taken")?.classList.add("hidden");
  //       form_errors = true;
  //     } else {
  //       if (input.type == "email") {
  //         //check with regex
  //         let result = this.validateEmail(value);
  //         if (result == false) {
  //           form_errors = true;
  //           field
  //             .querySelector(".invalid-email-error")
  //             .classList.remove("hidden");
  //           field.querySelector(".empty-field-error").classList.add("hidden");
  //           field.querySelector(".error-mail-taken")?.classList.add("hidden");
  //         } else {
  //           field.querySelector(".invalid-email-error").classList.add("hidden");
  //           field.querySelector(".empty-field-error").classList.add("hidden");
  //           field.querySelector(".error-mail-taken")?.classList.add("hidden");
  //         }
  //       } else {
  //         field.querySelector(".empty-field-error").classList.add("hidden");
  //       }
  //     }
  //   });
  //   if (form_errors != true) {
  //     document.querySelector(`${selector}`).click();
  //   }
  // }

  validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
  }

  openClosePasswordRecovery(e) {
    e.preventDefault();
    let action = e.currentTarget.dataset.action;
    if (action == "open") {
      this.loginTab.classList.remove("active");
      this.recoveryTab.classList.add("active");
    } else {
      this.loginTab.classList.add("active");
      this.recoveryTab.classList.remove("active");
    }
  }

  openTab(e) {
    this.closeTabs();
    let tabSelector = e.currentTarget.dataset.tab;
    e.currentTarget.classList.add("btn-active");
    this.querySelector(`.${tabSelector}`).classList.add("tab-active");
  }

  closeTabs() {
    this.querySelectorAll(".customer-entry-btn").forEach((btn) => {
      btn.classList.remove("btn-active");
    });
    this.querySelectorAll(".header-account-tab").forEach((tab) => {
      tab.classList.remove("tab-active");
    });
  }
}
if (!customElements.get("customer-entry-tabs")) {
  customElements.define("customer-entry-tabs", CustomerEntryTabs);
}

class AccountTabs extends HTMLElement {
  constructor() {
    super();
    this.tabBtns = this.querySelectorAll(".account-tab");
    this.mobileMenuLinks = this.querySelectorAll('.account-page-links .account-link:not(.logout-link)');
    this.headerOrdersBtn = document.querySelector('custom-header .account-link.orders-link');
    this.headerProfileBtn = document.querySelector('custom-header .account-link.profile-link');
  }

  connectedCallback() {
    this.headerOrdersBtn.addEventListener("click", this.openOrders.bind(this));
    this.headerProfileBtn.addEventListener("click", this.openProfile.bind(this));
    this.tabBtns.forEach((btn) => {
      btn.addEventListener("click", this.updateActiveTab.bind(this));
    });
    this.mobileMenuLinks.forEach(btn => {
      btn.addEventListener("click", this.mobileTabUpdate.bind(this));
    });
    this.tabInitialUpdate();
  }

  disconnectedCallback() {
    this.tabBtns.forEach((btn) => {
      btn.removeEventListener("click", this.updateActiveTab);
    });
    this.mobileMenuLinks.forEach((btn) => {
      btn.removeEventListener("click", this.mobileTabUpdate);
    });
  }

  openOrders(e) {
    e.preventDefault();
    this.querySelector('.account-tab[data-tab="orders"]').click();
    document.querySelector('.cover.close-menu').click();
  }

  openProfile(e) {
    e.preventDefault();
    this.querySelector('.account-tab[data-tab="profile"]').click();
    document.querySelector('.cover.close-menu').click();
  }

  tabInitialUpdate() {
    if (window.location.href.indexOf("#orders") > -1) {
      this.querySelector('.account-tab[data-tab="orders"]').click();
    } else if (window.location.href.indexOf("#profile") > -1) {
      this.querySelector('.account-tab[data-tab="profile"]').click();
    }
  }

  mobileTabUpdate(e) {
    let selectedTab = e.currentTarget.dataset.openTab;
    let tabToOpen = this.querySelector(`.account-tab[data-tab="${selectedTab}"]`);
    tabToOpen.click();
  }

  updateActiveTab(e) {
    e.preventDefault();
    let selectedTab = e.currentTarget.dataset.tab;
    this.closeAllTabs();
    this.querySelector(
      `.account-tab-content[data-tab=${selectedTab}]`
    ).classList.add("tab-active");
    this.changeUrl(selectedTab);
    e.currentTarget.classList.add("active");
  }

  changeUrl(selectedTab) {
    window.location.replace(`#${selectedTab}`);
  }

  closeAllTabs() {
    this.querySelectorAll(".account-tab-content").forEach((tab) => {
      tab.classList.remove("tab-active");
    });
    this.querySelectorAll(".account-tab").forEach((tab) => {
      tab.classList.remove("active");
    });
  }
}

if (!customElements.get("account-tabs")) {
  customElements.define("account-tabs", AccountTabs);
}

class ReturnsTable extends HTMLElement {
  constructor() {
    super();
    this.getData(0);
    this.statusJsonSelector = this.dataset.statusId;
    this.itemsJsonSelector = this.dataset.itemsId;
  }

  findItem(itemsJson, fullfillmentOrders, index) {
    for(let j=0; j < itemsJson.length; j++) {
      if(fullfillmentOrders[index].fulfillmentLineItem.lineItem.id.includes(`${itemsJson[j].id}`)) {
        return itemsJson[j];
      }
    }
  }

  renderTable(data) {
    let htmlString = ``;
    let returnsBtnHtml = `<a class="btn btn-filled-black mobile-btn-xs desktop-btn-xs view-returns-btn" href="https://shopify.com/65221263498/account/orders/${this.dataset.orderId}">View Returns</a>`
    data.returns.forEach( returnData => {
      htmlString = htmlString + `
      <table>
        <thead role="rowgroup">
          <tr role="row">
            <h3>Return ${returnData.name}</h3>
          </tr>
          <tr role="row">
            <th class="standard-03 regular" id="${returnData.id}_ReturnColumnProduct" scope="col" role="columnheader">Product</th>
            <th class="standard-03 regular" id="${returnData.id}_ReturnColumnQuantity" scope="col" role="columnheader">Quantity</th>
            <th class="standard-03 regular" id="${returnData.id}_ReturnColumnStatus" scope="col" role="columnheader">Return Status</th>
          </tr>
        </thead>
        <tbody>
      `
      returnData.items.forEach(item => {
        htmlString = htmlString + `
        <tr role="row">
          <td
            headers="${returnData.id}_ReturnColumnProduct"
            role="rowheader"
            scope="row"
            data-label="Product"
          >
            <a href="${item.product_url}" class="standard-03 regular">
              ${item.title}
            </a>
          </td>
          <td
            headers="${returnData.id}_ReturnColumnQuantity"
            role="rowheader"
            scope="row"
            data-label="Quantity"
          >
            <span class="standard-03 regular">
              ${item.quantity}
            </span>
          </td>
          <td
            headers="${returnData.id}_ReturnColumnStatus"
            role="rowheader"
            scope="row"
            data-label="Return Status"
          >
            <span class="standard-03 regular">
            ${item.custom_status}
            </span>
          </td>
        </tr>`

      });
      htmlString = htmlString + `</tbody></table>`;
    });
    if(htmlString != "") {
      htmlString = returnsBtnHtml + htmlString;
    }
    this.innerHTML = this.innerHTML + htmlString;
  }

  getData(index) {
    fetch(`https://middleware-bridge.gadget.app/api/order/${this.dataset.orderId}`)
    .then((response) => response.json())
    .then((obj) => {
      const returnsTable = document.querySelector('returns-table')
      const returns = document.querySelector(`#OrderReturnJSON-${returnsTable.dataset.orderId}`);
      const orderItems = document.querySelector(`#OrderItemsJSON-${returnsTable.dataset.orderId}`);
      const itemsJson = JSON.parse(orderItems.innerHTML);
      const returnsJson = JSON.parse(returns.innerHTML);
      const returnBtn = document.querySelector('.return-btn');
      let item_url;
      let orderItemsQuantity = 0;
      let returnedQuantity = 0;
      itemsJson.forEach( item => {
        if(item.fulfillment) {
          orderItemsQuantity +=item.quantity;
        }
      });
      let returnData = {
          "returns": []
      }
      let returnString='';
      obj.order.returns.nodes.forEach( function(node, index, array) { //Loops All of the returns of the order (R1 / R2 / R3 ...)
        let item;
        let returnLineItems = node.returnLineItems.nodes;
        if (node.status != "CANCELED" && node.status != "DECLINED") {
          node.returnLineItems.nodes.forEach(returnItem => {
            returnedQuantity += returnItem.quantity;
          });
        }
        if(returnLineItems[0]) {
          returnString = `{"name":"${node.name}","id":"${node.name.split('-').pop()}","items":[`;
          if(node.reverseFulfillmentOrders.nodes.length == 1) {
            let reverseFulfillmentOrders = node.reverseFulfillmentOrders.nodes[0].lineItems.nodes; // Gets the line items for the return

            let returnStatus = "";
            for(let i = 0; i < reverseFulfillmentOrders.length; i++) {
              item = returnsTable.findItem(itemsJson, reverseFulfillmentOrders, i);
              if(node.status != "CANCELED" && node.status != "DECLINED") {
                if (returnsJson[index].return_status == "") {
                  returnStatus = "In Progress"
                }
                else {
                  returnStatus = returnsJson[index].return_status;
                }
              }
              else {
                returnStatus = 'Declined';
              }
              if(item){
                item.url != undefined ? item_url = item.url : item_url = "#";
                if(returnLineItems[i]) {
                  if(i === reverseFulfillmentOrders.length - 1 && i != 0) {
                    returnString = returnString + `,{"title":"${item.title}","product_url":"${item_url}","quantity":"${returnLineItems[i].quantity}","custom_status": "${returnStatus}"}]`;
                  }
                  else if(i === reverseFulfillmentOrders.length - 1 && i === 0) {
                    returnString = returnString + `{"title":"${item.title}","product_url":"${item_url}","quantity":"${returnLineItems[i].quantity}","custom_status": "${returnStatus}"}]`;
                  }
                  else if(i === 0) {
                    returnString = returnString + `{"title":"${item.title}","product_url":"${item_url}","quantity":"${returnLineItems[i].quantity}","custom_status": "${returnStatus}"}`;
                  }
                  else {
                    returnString = returnString + `,{"title":"${item.title}","product_url":"${item_url}","quantity":"${returnLineItems[i].quantity}","custom_status": "${returnStatus}"}`;
                  }
                }
                else {
                  returnString = returnString + ']';
                }
              }
              else {
                returnString = returnString + ']';
              }
            }
            returnString = returnString + '}';
            returnData.returns.push(JSON.parse(returnString));
          }
          if (index != array.length){
            returnString = returnString + ',';
          }
        }
      });
      if(returnedQuantity < orderItemsQuantity) {
        returnBtn?.classList.remove('hide-btn');
      }
      this.renderTable(returnData);
    })
    .catch((e) => {
      console.error(e);
      if(index <=3) {
        index++;
        this.getData(index);
      }
    });
  }
}

if (!customElements.get("returns-table")) {
  customElements.define("returns-table", ReturnsTable);
}